import { api } from '@alltrails/core/utils/api';
import { get } from '@alltrails/core/utils/get';
import type {
  BelayUserConnection,
  ConnectionPageResponse,
  UserConnectionStatus
} from '@alltrails/types/belay';
import type { UserId } from '@alltrails/types/User';

const getConnectionsUrl = (status: UserConnectionStatus, userId: number): string => {
  switch (status) {
    case 'suggested-follow':
      return '/api/alltrails/connect/v0/my/suggestions';
    case 'mutual':
      return `/api/alltrails/connect/v0/my/mutuals/${userId}`;
    case 'blocking':
      return '/api/alltrails/connect/v0/my/blocks';
    default:
      return `/api/alltrails/connect/users/${userId}/connections?filter[statuses]=${status}`;
  }
};

export const getConnections = (status: UserConnectionStatus, userId: number) => {
  const url = getConnectionsUrl(status, userId);
  return get<ConnectionPageResponse>(url);
};

export const getConnectionsNextPage = (url: string) => get<ConnectionPageResponse>(url);

export const getReviewsConnections = (userIds: UserId[], userId?: number) =>
  get<ConnectionPageResponse>(`/api/alltrails/connect/users/${userId}/connections?filter[userIds]=${userIds}&limit=${userIds?.length}`);

export const getUserConnectionStatus = (userId: number, otherUserId: number) =>
  get<BelayUserConnection>(`/api/alltrails/connect/users/${userId}/connections/${otherUserId}`);

export const userActionRequest = (href: string, method: RequestInit['method']) =>
  api<BelayUserConnection>(href, { method });
